export default __webpack_public_path__ + "static/media/icon-photo-copy.1ace15cc.svg";